import axios from 'axios'
import { useEffect } from 'react'
import request from 'services/request'
import { ResponseBase } from 'services/responseBase'
import { NetworkModel, RewardConfigModel } from 'services/types/Application'
import { useAppDispatch } from 'state'
import { setUsdPrice } from 'state/application/reducer'

//
export function usePrice() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    axios.get('https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=usd').then(response => {
      if (response.status === 200) {
        if (response.data) {
          if (response.data.tether) {
            dispatch(setUsdPrice(response.data.tether.usd))
          }
        }
      }
    })
  }, [dispatch])
}

// tokenList
export function getTokenList(): Promise<ResponseBase> {
  return request.get<ResponseBase>('assets/token/v1/list')
}

// tokenList
export function queryRewardConfig(): Promise<ResponseBase> {
  return request.get<RewardConfigModel>('community/v1/queryRewardConfig')
}

// networkList
export function queryNetworkList(): Promise<ResponseBase> {
  return request.get<Array<NetworkModel>>('assets/token/v1/networkList')
}

export function upload(params: { file: FormData; onUploadProgress?: any; signal?: any }) {
  // console.log(params.signal)
  return request.post('gamezone/article/v1/upload', params.file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: params.onUploadProgress
      ? progressEvent => params.onUploadProgress(progressEvent)
      : progressEvent => console.log(progressEvent),
    timeout: 600000,
    signal: params.signal || null,
  })
}

export function commonUpload(params: { file: FormData }) {
  return request.post('/profile/v1/uploader/avatar', params.file, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    timeout: 150000,
  })
}
